export default __webpack_public_path__ + "static/media/vsk.c92f9449.svg";